import moment from 'moment-timezone';

/**
 * Converts hours in milliseconds to hours string in format 'hh:mm A'
 *
 * @param {number} time Time in milliseconds
 * @param {string} timezone Timezone restaurant timezone
 * @returns {string} Time string in format 'hh:mm A'
 */
export function timeToTimeString(time: number, timezone: string): string {
  return moment.tz(time, timezone).format('hh:mm A');
}
